<template>
  <div class="bg-white p-5 pb-1 mb-3 rounded">
    <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
      <div class="justify-content-star d-flex">
        <h3><strong style="color:#1A0054">Empresas</strong></h3>
      </div>
      <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
        <search-input-component :search="search" @onSearch="onFilterSearch"></search-input-component>
        <a :href="download" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2">Descarga reporte</a>
        <a href="#agregar_empresa" class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2">Agregar empresa</a>
      </div>
    </div>

    <company-table
      :companies="filteredCompanies"
      :loading="loading"
      :current-page="currentPage"
      :page-count="pageCount"
      :items-per-page="itemsPerPage"
      @edit-company="openEditModal"
      @delete-company="openDeleteModal"
      @page-change="handlePageChange"
    />

    <companies-create-component
      :licences="licences"
      :domains="domains"
      :urlvalidateemail="urlvalidateemail"
      :get="get"
      @refreshtable="onRefreshData"
    />

    <modal-delete-company
      v-if="deleteModalVisible"
      :company="selectedCompany"
      :url="get"
      @reloadtable="onReloadTable"
      @close="closeDeleteModal"
    />
    
    <modal-edit-company
      v-if="editModalVisible"
      :company="selectedCompany"
      :url="get"
      :licenses="licences"
      :urlrevisarplan="urlrevisarplan"
      :urlupdatephoto="photoupdate"
      @reloadtable="onReloadTable"
      @close="closeEditModal"
    />
  </div>
</template>
<script>
import CompanyTable from './CompanyTable.vue'
import ModalDeleteCompany from './ModalDeleteCompany.vue'
import ModalEditCompany from './ModalEditCompany.vue'

export default {
  components: {
    CompanyTable,
    ModalDeleteCompany,
    ModalEditCompany
  },
  
  props: {
    get: String,
    download: String,
    licences: Array,
    domains: Array,
    urlvalidateemail: String,
    urlrevisarplan: String,
    photoupdate: String
  },
  
  data() {
    return {
      companies: [],
      loading: false,
      search: '',
      currentPage: 1,
      itemsPerPage: 10,
      deleteModalVisible: false,
      editModalVisible: false,
      selectedCompany: {}
    }
  },
  
  computed: {
    filteredCompanies() {
      if (!this.search) return this.companies
      return this.companies.filter(company => 
        company.name.toLowerCase().includes(this.search.toLowerCase())
      )
    },
    pageCount() {
      return Math.ceil(this.filteredCompanies.length / this.itemsPerPage)
    }
  },
  
  mounted() {
    this.getData()
  },
  
  methods: {
    async getData() {
      this.loading = true
      try {
        const response = await axios.get(this.get)
        this.companies = response.data
      } catch (error) {
        console.error('Error loading companies:', error)
      } finally {
        this.loading = false
      }
    },
    
    onRefreshData() {
      this.$emit('refreshdatatable')
      this.getData()
    },
    
    onFilterSearch(searchText) {
      this.search = searchText
    },
    
    handlePageChange(page) {
      this.currentPage = page
    },
    
    openDeleteModal(company) {
      this.selectedCompany = company
      this.deleteModalVisible = true
    },
    
    openEditModal(company) {
      this.selectedCompany = company
      this.editModalVisible = true
    },
    
    closeDeleteModal() {
      this.deleteModalVisible = false
    },
    
    closeEditModal() {
      this.editModalVisible = false
    },
    
    onReloadTable() {
      this.getData()
    }
  }
}
</script>
